import { UseBaseMutationOptions } from '@/core/api/type'
import { ResetPassword, ResetPasswordResponse } from '@/modules/profile/types'
import { resetPassword } from '../../services'
import { useMutation } from '@tanstack/react-query'
import { ProfileMutationKey } from '@/modules/profile/keys'

export default function useMutationResetPassword(
	props?: UseBaseMutationOptions<ResetPasswordResponse, ResetPassword>,
) {
	return useMutation({
		mutationKey: [ProfileMutationKey.ResetPassword],
		mutationFn: (params) => resetPassword(params),
		...props,
	})
}
